export enum ControlTemplate {
	vertical = 'vertical',
	horizontal = 'horizontal',
	inputLeft = 'inputLeft',
	inputRight = 'inputRight',
	inline = 'inline',
	inlineFromTo = 'inlineFromTo',
	dateAndTime = 'dateAndTime'
}
